import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Icon from '../Atoms/Icon';
import Input from '../Atoms/Input';

const propTypes = exact({
  discountCodeValue: PropTypes.string,
  discountLabelText: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  hideDiscountInput: PropTypes.bool.isRequired,
  hidePriorityAccessPassInput: PropTypes.bool.isRequired,
  priorityAccessPassLabelText: PropTypes.string.isRequired,
  priorityAccessPassValue: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
});

const defaultProps = {
  discountCodeValue: '',
  priorityAccessPassValue: '',
  text: null,
  title: 'Discounts',
};

function Discount(props) {
  const discountClasses = classNames('Discount_field', { active: props.discountCodeValue !== '' });

  const priorityAccessPassClasses = classNames('Discount_field', {
    active: props.priorityAccessPassValue !== '',
  });

  return (
    <fieldset className="Discount">
      <h2 className="Discount_title">{props.title}</h2>
      {!props.hideDiscountInput && (
        <div className={discountClasses}>
          <Input
            blockName="Discount_input"
            fieldName="discountCode"
            fieldValue={props.discountCodeValue}
            handleChange={props.handleChange}
            inputType="text"
            modifier="ghost"
            placeholderText={props.discountLabelText}
          />
          <Icon blockName="Discount_icon" id="tick" />
        </div>
      )}
      {!props.hidePriorityAccessPassInput && (
        <div className={priorityAccessPassClasses}>
          <Input
            blockName="Discount_input"
            fieldName="priorityAccessPass"
            fieldValue={props.priorityAccessPassValue}
            handleChange={props.handleChange}
            inputType="text"
            modifier="ghost"
            placeholderText={props.priorityAccessPassLabelText}
          />
          <Icon blockName="Discount_icon" id="tick" />
        </div>
      )}
      {props.text && (
        <div
          className="Discount_body"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      )}
    </fieldset>
  );
}

Discount.propTypes = propTypes;
Discount.defaultProps = defaultProps;

export default Discount;
